import { render, staticRenderFns } from "./KhazinaClientSadadReportPrint.vue?vue&type=template&id=80fe2bea&"
import script from "./KhazinaClientSadadReportPrint.vue?vue&type=script&lang=js&"
export * from "./KhazinaClientSadadReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports